import * as styles from "./TemplatePageError.css";
import { Heading } from "../elements/Heading";
import { Paragraph } from "../elements/Paragraph";
import { ButtonLink } from "../elements/ButtonLink";
// @ts-ignore
import ArrowLeft from "@material-design-icons/svg/filled/arrow_back.svg?react";
import Grid from "../globals/Grid";

export default function TemplatePageError({
  heading = "Oh no!",
  text = "Looks like something went wrong.",
}: {
  heading?: string;
  text?: string;
}) {
  // console.log("TemplatePageError", data);

  return (
    <section className={styles.section}>
      <Grid>
        <div className={styles.grid}>
          <div className={styles.container}>
            <div className={styles.content}>
              {heading && (
                <Heading as="h1" size="h2">
                  {heading}
                </Heading>
              )}
              {text && <Paragraph>{text}</Paragraph>}
            </div>
          </div>
        </div>
      </Grid>
    </section>
  );
}
